import { CadastroForm } from "@/components/cadastro-form";
// import LogoEmpresa from "@/assets/logo-empresa.jpg";
import RfidReaderBanner from "@/assets/rfid-reader-banner.jpg";
import { Activity, Layers, Radio } from "lucide-react";
import { useTranslation } from "react-i18next";

function Cadastro() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      {/* Painel esquerdo: form */}
      <div className="relative flex flex-col gap-4 p-6 md:p-10 bg-gradient-to-br from-primary/5 via-background to-background">
        <div className="flex justify-center gap-2 md:justify-start">
          <span className="flex items-center gap-2 font-medium">
            {/* <img
              // src={LogoEmpresa}
              onClick={() =>
                window.open(
                  "https://www.inovacode.com.br",
                  "_blank",
                  "noopener,noreferrer",
                )
              }
              alt="iNOVACODE"
              className="h-8 w-auto max-w-[160px] object-contain cursor-pointer select-none"
            /> */}
          </span>
        </div>
        <div className="flex flex-1 items-center justify-center py-6">
          <div className="w-full max-w-md">
            <CadastroForm />
          </div>
        </div>
        <div className="text-center text-xs text-muted-foreground select-none">
          &copy; {new Date().getFullYear()} iNOVACODE RFID.{" "}
          {t("auth.rightsReserved")}
        </div>
      </div>

      {/* Painel direito: hero */}
      <div className="relative hidden lg:block overflow-hidden bg-muted">
        <img
          src={RfidReaderBanner}
          alt={t("auth.heroTitle")}
          className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.5] select-none"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/40 to-black/10 pointer-events-none" />

        <div className="absolute inset-0 flex flex-col items-start justify-end p-8 gap-6">
          <div className="space-y-2">
            <h2 className="text-3xl font-bold text-white tracking-tight select-none">
              {t("cadastro.heroTitle")}
            </h2>
            <p className="text-sm text-white/80 max-w-md select-none">
              {t("cadastro.heroSubtitle")}
            </p>
          </div>

          <ul className="grid gap-3 text-sm text-white/90 select-none">
            <li className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-white/10 backdrop-blur-sm ring-1 ring-white/15">
                <Radio className="h-4 w-4" />
              </span>
              <span>{t("auth.feature1")}</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-white/10 backdrop-blur-sm ring-1 ring-white/15">
                <Layers className="h-4 w-4" />
              </span>
              <span>{t("auth.feature2")}</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-white/10 backdrop-blur-sm ring-1 ring-white/15">
                <Activity className="h-4 w-4" />
              </span>
              <span>{t("auth.feature3")}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cadastro;
